import React, { useState } from "react";
import { DataGrid } from "Common/CusomReactGrid/CustomDataGrid";
import api from "http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import { useDispatch, useSelector } from "react-redux";
import { addPatient, removePatient, swtichTab } from "../../../Redux/TabsSlice/TabsSlice";
import NumberConversion from "Utils/NumberConversion";
import { toast } from "react-toastify";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import ConfirmationPopup from "Popups/ConfirmationPopup/ConfirmationPopup";
import { Tooltip } from "react-tooltip";
import ReactDOMServer from 'react-dom/server';
import CreateTaskPopup from "MainTabs/Tasks/Taskpopups/CreateTaskPopup";
import AddNewTagPopup from "Popups/AddNewTagPopup/AddNewTagPopup";
import ViewPatientStatementPopup from "Popups/ViewPatientStatementPopup/ViewPatientStatementPopup";
import MergePatientPopup from "Popups/MergePatientPopup/MergePatientPopup";
import FormatMomentDate from "Utils/FormatMomentDate";
import ThreeDotsIcon from "SVGS/ThreeDotsIcon";
import Dropdown from "Common/DropDown/Dropdown";
import Show from "Components/Show/Show";

const renderTooltipContent = (tags) => {
  return (
    <div>
      <h3 className="pb-1 mb-2 font-semibold border-b">Tags</h3>
      <div className="space-x-3 space-y-3">
        {tags.split(",").map((tag) => (
          <span className="bg-[#F4F6F7] rounded px-2 py-1 inline-flex items-center gap-1 text-black " key={tag}><span style={{ background: tag.split(":")[0] }} className="rounded-full size-2" />{tag.split(":")[1]}</span>
        ))}
      </div>
    </div>
  );
};


{/* <div data-tooltip-id="my-tooltip"
  data-tooltip-html={ReactDOMServer.renderToStaticMarkup(renderTooltipContent(row.linkedTags))}
  key={t} className="flex items-center justify-center  bg-[#F4F6F7] rounded p-3   h-7">
  <span style={{ background: t.split(":")[0] }} className="inline-block mr-1 bg-red-500 rounded-full size-2" />
  <div className="truncate">{t.split(":")[1]}</div>
</div> */}
const Tags = (row) => {
  if (row.linkedTags) {
    const tags = row.linkedTags.split(",").slice(0, 3).map((t) => {
      return (
        <div
          data-tooltip-id="PatientSearchGridTag_tooltip"
          data-tooltip-variant="light"
          data-tooltip-html={ReactDOMServer.renderToStaticMarkup(renderTooltipContent(row.linkedTags))}
          key={t}
          className="flex items-center justify-center  bg-[#F4F6F7] rounded p-3   h-7"
        >
          <span style={{ background: t.split(":")[0] }} className="inline-block mr-1 bg-red-500 rounded-full size-2" />
          <div className="truncate">{t.split(":")[1]}</div>
        </div>
      );
    });
    return tags;
  }
  return null
}
const PatientSearchGrid = ({
  handleSearchPatient,
  allPatients,
  pagination,
  handlePerRowsChange,
  handlePageChange,
  selectedRows,
  handleRowSelection,
  selectColumn,
  parentName = "",
  closePopup
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false)
  const [confirmActivePatient, setConfirmActivePatient] = useState({
    openPopup: false,
    Id: ""
  });
  const [taskPopup, setTaskPopup] = useState({ status: false, patientInfo: null })
  const [tagPopup, setTagPopup] = useState(false)
  const [openPatientStatementPopup, setOpenPatientStatementPopup] = useState({ status: false, data: null })
  const [mergePatientPopup, setMergePatientPopup] = useState({ status: false, patientId: null })
  const { patients } = useSelector((state) => state.tabs);


  // **************************** CreateTaskPopup Function Start ************************
  const openTaskPopup = (data) => {
    const { accountNum, id: patientId, firstName, lastName } = data
    const obj = {
      accountNum,
      patientId,
      patientName: `${firstName}, ${lastName}`
    }
    setTaskPopup({ status: true, patientInfo: obj })
  }
  const closeTaskPopup = () => {
    setTaskPopup({ status: false, patientInfo: null })
  }
  // **************************** CreateTaskPopup Function END ************************

  // **************************** AddNewTagPopup Function START ************************
  const openTagPopup = () => setTagPopup(true)
  const closeTagPopup = () => setTagPopup(false)
  // **************************** AddNewTagPopup Function END ************************

  // **************************** ViewPatientStatementPopup Function START ************************
  const closeGenerateStatementPopup = () => setOpenPatientStatementPopup({ status: false, data: null })
  const openGenerateStatementPopup = async (data) => {
    try {

      setLoading(true);
      const response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/PatientStatement/ViewOrGeneratePatientStatement`, {
        "visitIds": [],
        "patientIds": [data.id],
        "fileType": "pdf",
        "statementMessage": "",
        "viewOnly": true
      });
      const base64Content = response.data.dataModel.pdf_data[0]?.pdf_FileBase64Content;
      setOpenPatientStatementPopup({ status: true, data: base64Content })
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoading(false);
    }
  };
  // **************************** ViewPatientStatementPopup Function END ************************
  // **************************** MergePatientPopup Function START ************************
  const openMergePatientPopup = (data) => {
    setMergePatientPopup({ status: true, patientId: data.id })
  }
  const closeMergePatientPopup = (status) => {
    if (status) {
      const patientExist = patients.find((pat) => pat.id === mergePatientPopup.patientId)
      if (patientExist) {
        dispatch(removePatient(patientExist.id))
      }


    }
    setMergePatientPopup({ status: false, patientId: null })
  }
  // **************************** MergePatientPopup Function END ************************


  const onPatientClick = (data, subTab) => {
    if (parentName === "linkedPatient") {
      closePopup()
    }

    const obj = {
      active: true,
      id: data.id,
      accountNum: data.accountNum,
      subTab: subTab,
      name: `${data.lastName}, ${data.firstName} `,
      unsavedChanges: false,
      insuranceData: { status: false, editMode: false },
    };
    dispatch(addPatient(obj));
  };


  const changeStatus = async (status, id) => {
    try {
      setLoading(true);
      let response;
      if (status === "Archived") {
        const resp = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Patient/DeletePatient/${id}`, {});
        toast.success(resp.data.responseMessage);
        handleSearchPatient();
        setConfirmActivePatient({ openPopup: false, Id: "", status: "" });
      } else if (status === "UnArchive") {
        response = await api.post(`${process.env.REACT_APP_TC_PMS}/api/Patient/ReactivateArchivedPatient`, [id]);
        toast.success(response.data.responseMessage);
        handleSearchPatient();
        setConfirmActivePatient({ openPopup: false, Id: "", status: "" });
      }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoading(false);
    }
  };

  const handleArchiveClick = (row) => {
    setConfirmActivePatient({ Id: row.id, openPopup: true, status: "Archived" });
  };

  const handleUnarchiveClick = (row) => {
    setConfirmActivePatient({ Id: row.id, openPopup: true, status: "UnArchive" });
  };

  const handleAddClaim = row => {
    const claimSearch = {
      parentName: 'charges',
      subTabName: 'claim',
      subTabData: {
        visitId: null,
        patientId: row.id
      },
    }
    dispatch(swtichTab(claimSearch));

  }

  const columns = [
    {
      name: "Name",
      key: "first_name",
      renderCell: ({ row }) => {
        return (
          <div className="flex items-center justify-start text-ellipsis overflow-hidden w-[-webkit-fill-available]">
            <button
              onClick={() => {
                if (row.patientStatus !== "Archived" && parentName !== "tasks") {
                  onPatientClick(row, "Overview");
                }
              }}
              className={`text-sm font-medium ${row.patientStatus === "Archived" || parentName === "tasks" ? "text-gray-500 cursor-default" : "hover:text-primary cursor-pointer"}`}
            >
              {row.firstName} {row.lastName}
            </button>
          </div>
        );
      },
      cellClass: "showDropdownInGrid",
      width: 220,
    },
    { key: "accountNum", name: "Account No", width: 100 },
    {
      key: "dob", name: "DOB", width: 120,
      renderCell: ({ row }) => FormatMomentDate(row.dob)
    },
    {
      key: "primaryInsurance", name: "Payer", width: 300, minWidth: 300,
      renderCell: ({ row }) => {
        const hasPrimaryOrSecondary = row.primaryInsurance || row.secondaryInsurance;
        const tertiaryOnly = row.tertiaryInsurance && !row.primaryInsurance && !row.secondaryInsurance;
        const tooltipContent = `${row.primaryInsurance ? `${row.primaryInsurance}\n` : ''}${row.secondaryInsurance ? `Secondary: ${row.secondaryInsurance}\n` : ''}${row.tertiaryInsurance ? `Tertiary: ${row.tertiaryInsurance}\n` : ''}`;

        return (
          (hasPrimaryOrSecondary || tertiaryOnly) ? (
            <div className="inline-block max-w-full pt-2 text-sm " data-tooltip-id="payerTooltip"
              data-tooltip-content={tooltipContent} style={{ width: "auto", minWidth: 0 }}>
              <div className="flex flex-col">
                {hasPrimaryOrSecondary ? (
                  <>
                    {row.primaryInsurance}
                    <Show when={row.secondaryInsurance}>
                      <div className="inline-block text-xs text-secondaryLight">Secondary: {row.secondaryInsurance}</div>
                    </Show>
                  </>
                ) : (
                  <div className="inline-block text-xs text-secondaryLight">Tertiary: {row.tertiaryInsurance}</div>
                )}
              </div>
            </div>
          ) : (<span data-tooltip-id="payerTooltip" data-tooltip-content="Self-Pay">Self-Pay</span>)
        )
      }
    },
    {
      key: "balance", name: "Balance", width: 80,

      renderCell: ({ row }) => NumberConversion(row.balance)
    },
    {
      key: "patientCredit", name: "Credit", width: 80,

      renderCell: ({ row }) => NumberConversion(row.patientCredit)
    },
    {
      key: "linkedTags",
      name: "Tags",
      width: 140,
      renderCell: ({ row }) => Tags(row),
      cellClass: "flex justify-start items-center gap-2",
    },
    ...(parentName !== "tasks" && parentName !== "linkedPatient" ? [{
      key: "filters", name: "Action",
      width: 80,
      minWidth: 80,
      maxWidth: 80,
      renderCell: ({ row }) => {
        return (
          <div className='flex items-center justify-center h-full mr-5'>
            <Dropdown>
              <Dropdown.Button>
                <ThreeDotsIcon />
              </Dropdown.Button>
              <Dropdown.Menu>
                {row.patientStatus === "Active" ?
                  <>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => openTaskPopup(row)} >Create Task </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={openTagPopup} >Create Tag </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => handleAddClaim(row)} >Add Claim </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => openGenerateStatementPopup(row)} >View Statment </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => openMergePatientPopup(row)} >Merge Patient </Dropdown.MenuItem>
                    <Dropdown.MenuItem className="group rdx_item" onSelect={() => handleArchiveClick(row)} >Archive Patient </Dropdown.MenuItem>
                  </> :
                  <Dropdown.MenuItem className="group rdx_item" onSelect={() => handleUnarchiveClick(row)} >Unarchive Patient </Dropdown.MenuItem>
                }

              </Dropdown.Menu>
            </Dropdown>
          </div>
        );
      },
      cellClass: "showDropdownInGrid",
    }] : [])

  ];
  const patientArchiveStatus = confirmActivePatient.status === "Archived" ? "archive" : "Unarchive"
  return (
    <>
      {loading && <FullPageLoader allowFullScreen />}
      <Tooltip opacity={1} style={{ zIndex: 12, minWidth: 300, maxWidth: 300, boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }} id="PatientSearchGridTag_tooltip" />
      <Tooltip id="payerTooltip" style={{ zIndex: 9999, maxWidth: 300, whiteSpace: 'pre-line' }} />
      {confirmActivePatient.openPopup && (
        <ConfirmationPopup
          buttonTitle="Yes"
          onCancel={() => setConfirmActivePatient(prev => ({ ...prev, Id: "", openPopup: false }))}
          onConfirm={() => changeStatus(confirmActivePatient.status, confirmActivePatient.Id)}
          subHeading={`Are you sure you want to ${patientArchiveStatus} the selected patients?`}
        />
      )}

      {taskPopup.status && <CreateTaskPopup onClose={closeTaskPopup}
        patientInfo={[taskPopup.patientInfo]}

      />}
      {tagPopup && <AddNewTagPopup onClose={closeTagPopup} tagId={0} allowActive={false} />}
      {openPatientStatementPopup.status && <ViewPatientStatementPopup onClose={closeGenerateStatementPopup} ViewPdf={{ value: openPatientStatementPopup.data, type: "base64" }} />}
      {mergePatientPopup.status && <MergePatientPopup onClose={closeMergePatientPopup} patientId={mergePatientPopup.patientId} />}
      <DataGrid
        gridHeightOffset={parentName === "tasks" ? 320 : 200}
        paginationDefaultPage={1}
        columns={columns}
        rows={allPatients}
        pagination={{
          perPage: pagination.perPage,
          pageNo: pagination.pageNo,
          totalCount: pagination.totalCount,
        }}

        rowHeight={45}
        manualPagination={true}
        handlePerRowsChange={handlePerRowsChange}
        handlePageChange={handlePageChange}
        formId="patientSearchGridForm"
        selectColumn={selectColumn}
        onSelectedRowsChange={handleRowSelection}
        selectedRows={selectedRows}
      />
    </>
  );
};

export default PatientSearchGrid;
